let dd = require('ES/lib/dd');
let _ = require('ES/lib/lodash');
let radio = require('ES/lib/radio');
let esUtils = require('ES/utils/esUtils');
let FormMixin = require('ES/widgets/forms/FormMixin');
let FormUtils = require('../../../utils/FormUtils');
let RadioMixin = require('ES/utils/RadioMixin');
let ErrorAlert = require('ES/widgets/ErrorAlert');
let LoadingWrap = require('ES/widgets/LoadingWrap');
let SlideOpenDown = require('../../widgets/SlideOpenDown');
let HorizontalFields = require('ES/widgets/HorizontalFields');
let AuthedUserSession = require('../../../utils/AuthedUserSession');

let SubscribeForm = dd.createClass({
    mixins: [FormMixin],
    getInitialValuesSourceVersion: function (props) {
        return props.ical_feed ? props.ical_feed.calid : -1;
    },
    getInitialValues: function (props) {
        return {
            url: props.ical_feed ? props.ical_feed.url : '',
            tzoffset: (props.ical_feed ? props.ical_feed.tzoffset : 0) + '_THIS_MAY_LOOK_LIKE_A_NUMBER_BUT_ITs_NOT'//look at the way this fields options are made
        };
    },
    buildFields: function () {
        return {
            url: {
                label: 'iCalendar URL',
                type: 'text',
                validate: FormUtils.v.optional
            },
            tzoffset: {
                label: 'Adjust time',
                type: 'select',
                dont_sort_options: true,
                options: _.object(_.map(_.range(-12, 12), function (hours) {
                    return [
                        hours + '_THIS_MAY_LOOK_LIKE_A_NUMBER_BUT_ITs_NOT',//hack so _.fromPairs doesn't sort the keys
                        hours === 0 ? 'no change' : ((hours > 0 ? '+' : '') + hours + ' hours')
                    ];
                }))
            }
        };
    },
    __discardChanges: esUtils.wrapPreventDefault(function () {
        this._form_reset();
    }),
    render: function () {
        let fields = this.buildFields();
        let errors = this.state.errors || {};
        let changes_made = this._form_areChangesMade();

        return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
            HorizontalFields({
                fields: fields,
                errors: errors,
                buildInput: this._form_buildInput
            }),
            SlideOpenDown({open: changes_made},
                HorizontalFields.FormButtons({onDiscard: this.__discardChanges})
            )
        );
    }
});

let PublishForm = dd.createClass({
    mixins: [FormMixin],
    getInitialValues: function (props) {
        return {
            confirmed: true
        };
    },
    buildFields: function () {
        let Displaylists = this.props.Displaylists;

        let schema = {
            confirmed: {label: 'include confirmed events', read_only: true},
            holds: {label: 'include holds'},
            leads: {label: 'include leads'},
            conference: {label: 'include conference calls'},
            travel: {label: 'include flight & ground travel'},
            personal: {label: 'include personal dates'},
            timezone: {
                label: 'Your Time Zone',
                type: 'select',
                placeholder: '-- select home time zone --',
                options: _.object(_.map(Displaylists && Displaylists.universal && Displaylists.universal.timezones, function (timezone) {
                    return [timezone, timezone];
                })),
                validate: FormUtils.optional
            },
            travel_filter: {
                label: 'Travel Filter',
                type: 'text',
                help_text: 'Only flight and ground items that include this text in the description will be exported.',
                validate: FormUtils.optional
            }
        };
        return _.mapValues(schema, function (field) {
            if (!field.type) {
                field.type = 'checkbox';
            }
            return field;
        });
    },
    render: function () {
        let fields = this.buildFields();
        let errors = this.state.errors || {};

        return dd.form({className: 'form-horizontal', onSubmit: this._form_onSubmit},
            HorizontalFields({
                fields: fields,
                errors: errors,
                buildInput: this._form_buildInput
            }),
            HorizontalFields.FormButtons({submit_btn_text: 'Show my URL'})
        );
    }
});

module.exports = dd.createClass({
    mixins: [RadioMixin],
    getInitialState: function () {
        return {
            ical_published_url: null,
            subscribe_saving: false,
            subscribe_error_msg: null,
            generate_error_msg: null,
            generate_saving: false
        };
    },
    componentWillMount: function () {
        let self = this;
        self.radio = {
            save_iCalFeed: function (sid, ical_feed) {
                if (self.props.selected_sid === sid) {
                    self.setState({subscribe_saving: true, subscribe_error_msg: null});
                }
            },
            save_iCalFeed_succeeded: function (sid) {
                if (self.props.selected_sid === sid) {
                    self.setState({subscribe_saving: false, subscribe_error_msg: null});
                }
            },
            save_iCalFeed_failed: function (sid, message) {
                if (self.props.selected_sid === sid) {
                    self.setState({subscribe_saving: false, subscribe_error_msg: 'Failed to save: ' + message});
                }
            },
            read_iCalExportURL_succeeded: function (sid, export_url) {
                if (self.props.selected_sid === sid) {
                    self.setState({generate_saving: false, generate_error_msg: null, ical_published_url: export_url});
                }
            },
            read_iCalExportURL_failed: function (sid, message) {
                if (self.props.selected_sid === sid) {
                    self.setState({generate_saving: false, generate_error_msg: message ? message : 'Failed to generate export URL.'});
                }
            }
        };
    },

    __onSubscribeSubmit: function (data) {
        let selected_sid = this.props.selected_sid;
        let ical_feed = this.__getSelectedSIDsiCal();
        if (!ical_feed) {
            ical_feed = {calid: -1};
        }
        ical_feed.url = data.url;
        ical_feed.tzoffset = _.parseInt(data.tzoffset);//yep needs to be parsed int - look at the way this fields options are made
        radio('save_iCalFeed').broadcast(selected_sid, ical_feed);
    },
    __onPublishSubmit: function (data) {
        let {selected_sid} = this.props;

        let params = {
            sid: selected_sid,
            loginid: _.get(AuthedUserSession, "MY_USERNAME"),
            holds: !!data.holds,
            leads: !!data.leads,
            calls: !!data.conference,
            flights: !!data.travel,
            personal: !!data.personal,
            tz: data.timezone,
            travel_filter: data.travel_filter
        };

        radio('read_iCalExportURL').broadcast(selected_sid, params);
    },

    __getSelectedSIDsiCal: function () {
        let selected_sid = this.props.selected_sid;
        let Displaylists = this.props.Displaylists;
        let speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
            return spkr.sid == selected_sid;
        });
        return speaker && speaker.ical_feed;
    },

    __selectTextInput: function (e) {
        e.target.setSelectionRange(0, e.target.value.length);
    },

    __resetGenerateForm: function () {
        this.setState({ical_published_url: null});
    },

    render: function () {
        let Displaylists = this.props.Displaylists;
        let ical_feed = this.__getSelectedSIDsiCal();
        let ical_published_url = _.get(this.state, 'ical_published_url');
        let generate_error_msg = _.get(this.state, 'generate_error_msg');

        return dd.div({className: 'row'},
            dd.div({className: 'col-sm-5'},
                dd.h3(null, 'Export speaking calendar'),
                dd.p({className: 'text-muted'},
                    'Send your speaking calendar from here to all of your other calendars with an iCalendar feed.'
                ),
                ical_published_url ? dd.div(null,
                    dd.p({style: {marginTop: "2em"}}, 'Copy this url and paste it into your application:'),
                    dd.textarea({style: {fontFamily: 'monospace', height: "10em"}, type: 'text', value: ical_published_url, className: 'form-control', onFocus: this.__selectTextInput, readOnly: 'readonly'}),
                    dd.a({style: {cursor: "pointer"}, className: "pull-right", onClick: this.__resetGenerateForm}, "(change settings)")
                    )
                    :
                    dd.div(null,
                        generate_error_msg ? dd.div({className: "alert alert-danger"},
                            generate_error_msg
                        ) : null,
                        PublishForm({onSubmit: this.__onPublishSubmit, Displaylists: Displaylists})
                    ),
                dd.a({href: "https://espeakers.com/wiki/Export_your_events_to_other_calendar_programs", target: "_blank", style: {marginTop: "2em", display: "block"}},
                    dd.i({className: "fa fa-question-circle", style: {marginTop: "2em", marginRight: "0.5em"}}),
                    "How do I use this iCalendar URL?")
            ),
            dd.div({className: 'col-sm-5 col-sm-offset-2'},
                LoadingWrap({is_loading: this.state.subscribe_saving, glass: true},
                    dd.h3(null, 'Import daily calendar'),
                    dd.p({className: 'text-muted'},
                        'Display an iCalendar feed as "Daily" items on your eSpeakers calendar.'
                    ),
                    dd.p({className: 'text-muted'},
                        dd.i({className: "fa fa-info-circle", style: {marginRight: "0.5em"}}),
                        "Prepare for longer EventCX start times when loading a large calendar."
                    ),
                    dd.p({className: 'text-muted'},
                        dd.i({className: "fa fa-info-circle", style: {marginRight: "0.5em"}}),
                        "Daily calendars are refreshed at most every 24 hours."
                    ),
                    ErrorAlert({message: this.state.subscribe_error_msg}),
                    SubscribeForm({ical_feed: ical_feed, onSubmit: this.__onSubscribeSubmit})
                ),
                dd.a({href: "https://espeakers.com/wiki/Import_Google_Calendar_into_EventCX", target: "_blank", style: {marginTop: "2em", display: "block"}},
                    dd.i({className: "fa fa-question-circle", style: {marginRight: "0.5em"}}),
                    "How do I import daily items from a Google calendar?")
            )
        )
            ;
    }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/connect/iCalFeed.js